export const address_type = [
	{ label: 'Local', value: 'LOCAL' },
	{ label: 'International', value: 'INTERNATIONAL' },
];
